/**
   * @ngdoc directive
   * @name adjust.directive:modal
   * @scope
   * @restrict E
   *
   * @description
   * Simple confirmation dialog (to be improved)
   *
   * @param {string} tpl template to be included in the modal
   * @param {string} title title of the modal
   * @param {string} confirmBtn confirm button text
   * @param {string} cancelBtn cancel button text
   * @param {string} align content alignment
   * @param {string} message message to show in modal
   * @param {boolean} hideCancel hide cancel button
   * @param {boolean} hideConfirm hide confirm button
   * @param {string} size predefined size of the modal
   *
   */
function modal() {
  'ngInject';
  return {
    restrict: 'E',
    template: require('./modal.html'),
    scope: {},
    controller: 'ModalController',
    controllerAs: 'vm',
    bindToController: {
      title: '@',
      confirmBtn: '@',
      cancelBtn: '@',
      align: '@',
      message: '@',
      hideCancel: '=',
      hideConfirm: '=',
      size: '@',
      isConfirm: '='
    }
  };
}

/**
   * @ngdoc controller
   * @name adjust.controller:ModalController
   *
   * @description
   * All the functionality of the {@link adjust.directive:modal modal} directive
   *
   */
function ModalController(Modal, Helper, gettextCatalog, $timeout, $element, configuration) {
  'ngInject';
  var vm = this;

  var _instance;

  vm.isBeta = configuration.isBeta;

  vm.close = close;
  vm.cancel = cancel;

  Helper.ready(_handleReady);

  /**
   * @ngdoc method
   * @name _handleReady
   * @methodOf adjust.controller:ModalController
   *
   * @description
   * Handle ready state, when scope is digested
   *
   * @private
   */
  function _handleReady() {

    _instance = Modal.getInstance();

    if (!_instance) {
      throw new Error('This directive is used only and only by Modal service');
    }

    $element.removeAttr('title'); // remove attribute to avoid showing tooltip

    vm.language = gettextCatalog.getCurrentLanguage(); // used in confirm-ctp.html
    vm.align = vm.align || 'center';
    vm.size = vm.size || 'small';
    vm.model = _instance.initialModel || {};
    vm.tpl = _instance.tpl || '';

    Modal.registerTid($timeout(function() {
      $element.addClass('modal-window-visible');
    }, 100));

  }

  /**
   * @ngdoc method
   * @name close
   * @methodOf adjust.controller:ModalController
   *
   * @description
   * Initiate modal close
   *
   */
  function close() {

    if (vm.disabled) { return; }

    vm.disabled = true;

    _instance.close(vm.model);

  }

  /**
   * @ngdoc method
   * @name cancel
   * @methodOf adjust.controller:ModalController
   *
   * @description
   * Initiate modal cancel
   *
   */
  function cancel() {

    if (vm.disabled) { return; }

    vm.disabled = true;

    _instance.cancel();

  }
}


export { ModalController, modal };
